import { fileName } from 'Regex';
import { AUDIO_VIDEO_EXTENSIONS } from 'Config';

export const isAudioVideoFile = (fileName: string): boolean => {
  const lowerFileName = fileName.toLowerCase();
  return AUDIO_VIDEO_EXTENSIONS.some((ext) =>
    lowerFileName.includes(`.${ext}`)
  );
};

export const files = async () => {
  const files = document.querySelectorAll('button[data-required="true"]');
  if (!files) return true;

  let filesDup: Element[] = [...Array.from(files)];
  for (let i = 0; i < files.length; i++) {
    const requiredWith = JSON.parse(
      files[i].getAttribute('data-required-with') || '[]'
    );
    for (let j = 0; j < requiredWith.length; j++) {
      const requiredWithElement = document.querySelector(
        `button[data-id="${requiredWith[j]}"]`
      );

      if (
        requiredWithElement &&
        requiredWithElement.getAttribute('data-required') === 'false'
      ) {
        filesDup = filesDup.filter(
          (file) =>
            file.getAttribute('data-id') !== files[i].getAttribute('data-id')
        );
      }
    }
  }

  if (filesDup.length) {
    const btn = filesDup[0] as HTMLButtonElement;

    if (btn) {
      btn.setAttribute('aria-invalid', 'true');

      let span = btn.nextElementSibling as HTMLSpanElement;
      if (!span || span.innerText !== 'שדה חובה') {
        span = document.createElement('span');
        span.innerText = 'שדה חובה';
        if (btn) {
          btn.insertBefore(span, btn.nextSibling);
        }
      }
      span.style.display = 'flex';
      span.style.flexDirection = 'column';
      span.style.fontSize = '14px';
      span.style.color = '#d90000';
      span.style.position = 'absolute';
      span.style.bottom = '-25px';

      btn.style.color = '#d90000';
      btn.style.borderColor = '#d90000';
      btn.focus();
      return false;
    }
  }
  return true;
};

export const getCleanFileName = (name: string) => {
  const extensionIndex = name?.lastIndexOf('.');
  const cleanPart =
    name?.slice(0, extensionIndex).replaceAll(fileName, '') ||
    'Filename_' + new Date().getTime().toString()?.slice(0, -3);
  const cleanName =
    cleanPart + '.' + name?.slice(extensionIndex).replaceAll(fileName, '');

  return cleanName;
};

export const getFileTypeFromBase64 = (
  base64: string,
  originalFileName?: string
): string => {
  try {
    // Support data URL prefix like: data:image/jpeg;base64,....
    const commaIndex = base64.indexOf(',');
    const pureBase64 = commaIndex > -1 ? base64.slice(commaIndex + 1) : base64;

    const buffer = Uint8Array.from(window.atob(pureBase64), (c) =>
      c.charCodeAt(0)
    );

    // Images
    const isJPG =
      buffer[0] === 0xff && buffer[1] === 0xd8 && buffer[2] === 0xff; // JPEG SOI
    const isPNG =
      buffer[0] === 0x89 &&
      buffer[1] === 0x50 &&
      buffer[2] === 0x4e &&
      buffer[3] === 0x47 &&
      buffer[4] === 0x0d &&
      buffer[5] === 0x0a &&
      buffer[6] === 0x1a &&
      buffer[7] === 0x0a;
    const isGIF =
      buffer[0] === 0x47 &&
      buffer[1] === 0x49 &&
      buffer[2] === 0x46 &&
      buffer[3] === 0x38; // GIF87a/89a
    const isWEBP =
      buffer[0] === 0x52 && // 'RIFF'
      buffer[1] === 0x49 &&
      buffer[2] === 0x46 &&
      buffer[3] === 0x46 &&
      buffer[8] === 0x57 && // 'WEBP'
      buffer[9] === 0x45 &&
      buffer[10] === 0x42 &&
      buffer[11] === 0x50;
    const isBMP = buffer[0] === 0x42 && buffer[1] === 0x4d; // 'BM'
    const isTIFF =
      (buffer[0] === 0x49 &&
        buffer[1] === 0x49 &&
        buffer[2] === 0x2a &&
        buffer[3] === 0x00) || // little-endian
      (buffer[0] === 0x4d &&
        buffer[1] === 0x4d &&
        buffer[2] === 0x00 &&
        buffer[3] === 0x2a); // big-endian

    // Documents
    const isPDF =
      buffer[0] === 0x25 &&
      buffer[1] === 0x50 &&
      buffer[2] === 0x44 &&
      buffer[3] === 0x46;

    // Audio
    const isMP3 =
      buffer[0] === 0xff && (buffer[1] === 0xfb || buffer[1] === 0xf3);
    const isWAV =
      buffer[0] === 0x52 && // 'RIFF'
      buffer[1] === 0x49 &&
      buffer[2] === 0x46 &&
      buffer[3] === 0x46 &&
      buffer[8] === 0x57 && // 'WAVE'
      buffer[9] === 0x41 &&
      buffer[10] === 0x56 &&
      buffer[11] === 0x45;
    const isOGG =
      buffer[0] === 0x4f &&
      buffer[1] === 0x67 &&
      buffer[2] === 0x67 &&
      buffer[3] === 0x53;

    // Video / containers (very rough; many ISO-BMFF formats start with size + 'ftyp' at 4-7)
    const looksLikeISOBaseMedia =
      buffer[4] === 0x66 &&
      buffer[5] === 0x74 &&
      buffer[6] === 0x79 &&
      buffer[7] === 0x70; // 'ftyp'

    // HEIC/HEIF brands within ISO-BMFF
    const brand = String.fromCharCode(
      buffer[8] || 0,
      buffer[9] || 0,
      buffer[10] || 0,
      buffer[11] || 0
    );
    const isHEIC = looksLikeISOBaseMedia && /heic|heif|mif1|msf1/.test(brand);

    // MP4 common brands: isom, mp41, mp42, avc1, iso2, iso6, dash
    const isMP4 =
      looksLikeISOBaseMedia && /isom|iso2|mp41|mp42|avc1/.test(brand);

    if (isPDF) return 'pdf';
    if (isJPG) return 'jpg';
    if (isPNG) return 'png';
    if (isGIF) return 'gif';
    if (isWEBP) return 'webp';
    if (isBMP) return 'bmp';
    if (isTIFF) return 'tiff';
    if (isHEIC) return 'heic';
    if (isMP4) return 'mp4';
    if (isMP3) return 'mp3';
    if (isWAV) return 'wav';
    if (isOGG) return 'ogg';

    // Fallback: try to determine from original filename if provided
    if (originalFileName) {
      const extension = originalFileName.toLowerCase().split('.').pop();
      if (
        extension &&
        [
          'mp4',
          'mov',
          'avi',
          'webm',
          'mp3',
          'wav',
          'ogg',
          'pdf',
          'doc',
          'docx',
          'jpg',
          'jpeg',
          'jfif',
          'png',
          'gif',
          'webp',
          'bmp',
          'tiff',
          'tif',
        ].includes(extension)
      ) {
        return extension;
      }
    }

    // Default to PDF if we can't determine the type
    return 'pdf';
  } catch (error) {
    console.error('Error detecting file type from base64:', error);
    // Fallback: try to determine from original filename if provided
    if (originalFileName) {
      const extension = originalFileName.toLowerCase().split('.').pop();
      if (
        extension &&
        [
          'mp4',
          'mov',
          'avi',
          'webm',
          'mp3',
          'wav',
          'ogg',
          'pdf',
          'doc',
          'docx',
          'jpg',
          'jpeg',
          'jfif',
          'png',
          'gif',
          'webp',
          'bmp',
          'tiff',
          'tif',
        ].includes(extension)
      ) {
        return extension;
      }
    }
    return 'pdf';
  }
};
